"use client";
import React, { useEffect, useRef, useState } from "react";
import { setOverflow } from "@/lib/utils/util";

type Props = {
	direction?: "left" | "right";
	width?: string;
	visible: boolean;
	title?: string;
	showClose?: boolean;
	showHeader?: boolean;
	children?: React.ReactNode;
	onClose: () => void;
	className?: string;
};

function Drawer({
	direction = "left",
	width = "40vw",
	visible,
	title = process.env.NEXT_PUBLIC_COMPANY_NAME!.toUpperCase(),
	showClose = true,
	showHeader = true,
	children,
	onClose,
	className = "",
}: Props) {
	const drawerRef = useRef<HTMLDivElement>(null);

	const contentRef = useRef<HTMLDivElement>(null);

	const [open, setOpen] = useState(false);

	const handlerClose = () => {
		onClose();
		setOpen(false);
	};
	// esc 关闭
	useEffect(() => {
		const handleKeydown = (e: KeyboardEvent) => {
			if (e.key === "Escape") {
				handlerClose();
			}
		};
		document.addEventListener("keydown", handleKeydown);
		return () => {
			document.removeEventListener("keydown", handleKeydown);
		};
	}, []);

	useEffect(() => {
		setOpen(visible);
		if (contentRef.current && visible) {
			if (direction === "left") {
				contentRef.current.classList.remove("animate__slideInRight");
				contentRef.current.classList.add("animate__slideInLeft");
			} else {
				contentRef.current.classList.remove("animate__slideInLeft");
				contentRef.current.classList.add("animate__slideInRight");
			}
		}
	}, [visible, width, contentRef.current, direction]);

	useEffect(() => {
		setOverflow(open ? "hidden" : "auto");
	}, [open]);

	return (
		<div
			className={`fixed bottom-0 left-0 right-0 top-0 !z-[99999] ${open ? "block" : "hidden"}`}
			ref={drawerRef}
		>
			<div
				className="drawer-mask absolute inset-0 bg-[rgba(0,0,0,0.45)]"
				onClick={() => handlerClose()}
			></div>
			<div
				style={{
					width: width,
				}}
				ref={contentRef}
				className={`drawer-content   ${
					direction === "left" ? "left-0" : "right-0"
				} animate__animated animate__delay-10 absolute
            z-[4] h-[100vh] overflow-y-auto bg-white ${className}`}
			>
				{showHeader && (
					<div className="flex h-[90px] items-center justify-between px-8 ">
						<h2 className="font-poppins text-[26px] font-bold ">{title || ""}</h2>
						{showClose ? (
							<i className="ri-close-line cursor-pointer text-[40px]" onClick={() => handlerClose()}></i>
						) : null}
					</div>
				)}
				{children}
			</div>
		</div>
	);
}

export default React.memo(Drawer);
